const fr: Record<string, string> = {
  'features.guitarMetronome.title': 'Métronome',
  'features.guitarMetronome.start': 'Démarrer',
  'features.guitarMetronome.stop': 'Arrêter',
  'features.guitarMetronome.tap': 'Taper',
  'features.guitarMetronome.beatsPerBar': 'Temps par mesure',
  'features.guitarMetronome.accentOn': 'Accent sur le 1',
  'features.guitarMetronome.accentOff': 'Sans accent',
};

export default fr;
